require('../../modules/es.string.includes');

module.exports = require('../../internals/entry-unbind')('String', 'includes');
